import { Typography, Card, Input, TimePicker, Button, Form, Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";

import { ReportIssuesPageProps } from "containers/Pages/User/Contact/ReportIssues";
import FloatLabel from "components/Common/FloatLabel";
import moment from "moment";

import './index.scss';

const { Title } = Typography;
const { TextArea } = Input;

const ReportIssueForm = (props: ReportIssuesPageProps) => {

  const [form] = Form.useForm();

  const onSubmit = (formValues: any) => {

    let formObject = {
      ...formValues,
      "Hours" : formValues.Hours ? moment(formValues.Hours).format('hh:mm A') : null,
      "UserId": sessionStorage.getItem('user_id'),
      "Location": "/ContactUs/ReportIssues",
      "Ipa": sessionStorage.getItem('ipaGroup'),
    };

    return props.reportIssue(formObject)
      .then((response: number) => {
        if (response === 1) {// Success
          Modal.success({
            title: 'Thanks for your help.',
            content: 'We will contact you regarding this issue as soon as possible.',
          });
          form.resetFields();
        } else {
          Modal.error({
            title: 'Something went wrong.',
            content: 'There was an error sending your request. Please try again later.',
          });
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  return (
    <Card className="form flex-lg-wrap">
      <Title level={5}><WarningOutlined /> Report an Issue</Title>

      <Form form={form} name="reportIssueForm" onFinish={onSubmit}>

        <FloatLabel
          label="Contact Name"
          form={form}
          name="Contact"
          required
          rules={[
            () => ({
              validator(_: any, value: string) {
                if (value && value.trim().length < 2) {
                  return Promise.reject(new Error('Please enter at least 2 characters.'));
                }
                return Promise.resolve();
              }
            })
          ]}
        >
        <Input />
        </FloatLabel>

        <FloatLabel
          label="Phone Number"
          form={form}
          name="PhoneNumber"
          required
          rules={[
            () => ({
              validator(_: any, value: string) {
                if (value && !value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
                  return Promise.reject('Please enter a valid phone number.');
                }
                return Promise.resolve();
              }
            })
          ]}
        >
        <Input type="tel" />
        </FloatLabel>

        <FloatLabel
          label="Best Time to Call"
          form={form}
          name="Hours"
        >
        <TimePicker
          placeholder={''}
          use12Hours
          showSecond={false}
          allowClear
        />
        </FloatLabel>

        <FloatLabel
          label="Email Address"
          form={form}
          name="Email"
          required
          rules={[
            () => ({
              validator(_: any, value: string) {
                if (value && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                  return Promise.reject('Please enter a valid email address.');
                }
                return Promise.resolve();
              }
            })
          ]}
        >
        <Input type="email" />
        </FloatLabel>

        <FloatLabel
          label="Claim or Authorization Number"
          form={form}
          name="ClaimOrAuth"
          required
        >
        <Input />
        </FloatLabel>

        <FloatLabel
          label="Comment"
          form={form}
          name="Comment"
          required
        >
        <TextArea
          rows={4}
        />
        </FloatLabel>

        <div className="btn-wrapper d-flex justify-content-end">
          <Button type="primary" htmlType={'submit'} loading={props.isReporting}>Submit</Button>
          <Button htmlType={'reset'}>Cancel</Button>
        </div>

        <div className="d-flex justify-content-start">
          Required Fields <span style={{ color: 'red' }}>*</span>
        </div>

      </Form>
    </Card>
  );
};

export default ReportIssueForm;